import React, { useMemo } from 'react';
import { formatCurrency, getCurrencyLogo } from '../../../../../utils/global';
import CustomTooltip from '../../../../common-components/CustomTooltip/CustomTooltip';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useSelector } from 'react-redux';
import '../../styles/request-usage-rights-modal.scss';
import ShortString from '../../../../common-components/ShortString/ShortString';

const ViewUsageRightOffer = ({ post }) => {
  const { userDetails } = useSelector((state) => state.user);
  const currency = userDetails?.defaultCurrency;
  const isRevisedRequest = post?.usageRequestChanges?.payment !== undefined;
  const isPayWithProduct = Boolean(post?.usageRequest?.ugcFreeProducts?.length);

  const totalOfferPrice = useMemo(() => {
    let price = 0;
    if (post?.usageRequest?.ugcFreeProducts) {
      for (const product of post?.usageRequest?.ugcFreeProducts) {
        price +=
          parseFloat(product?.productDetails?.productPrice) * product?.quantity;
      }
    }
    return price;
  }, [post]);

  const renderNumericOffer = () => {
    if (isPayWithProduct && !isRevisedRequest) {
      return (
        <div className="view-usage-rights__terms__section__right__original">
          {formatCurrency(totalOfferPrice, currency)} Free Product
        </div>
      );
    }

    return isRevisedRequest ? (
      <>
        <div className="view-usage-rights__terms__section__right__old">
          {formatCurrency(post?.usageRequest?.payment, currency)}
        </div>
        <div className="view-usage-rights__terms__section__right__new">
          {formatCurrency(post?.usageRequestChanges?.payment, currency)}
        </div>
        <div className="view-usage-rights__terms__section__right_info">
          <CustomTooltip title="Revised Duration" placement="top">
            <ErrorOutlineIcon />
          </CustomTooltip>
        </div>
      </>
    ) : (
      <div className="view-usage-rights__terms__section__right__original">
        {formatCurrency(post?.usageRequest?.payment, currency)}
      </div>
    );
  };

  const renderPayWithProduct = () => {
    if (isPayWithProduct && !isRevisedRequest) {
      return (
        <>
          <div className="view-usage-rights-products-title">Product(s)</div>
          {post.usageRequest.ugcFreeProducts.map(
            ({ variantId, productDetails }) => (
              <div className="view-usage-rights-products-item" key={variantId}>
                <div className="view-usage-rights-products-item-left">
                  <div className="view-usage-rights-products-item-image-container">
                    <img src={productDetails?.productImage} alt="" width={52} />
                  </div>
                  <div className="view-usage-rights-products-item-text-container">
                    <div className="view-usage-rights-products-item-text-title">
                      <ShortString
                        name={productDetails?.productName}
                        stringLength={18}
                      />
                    </div>
                    <div className="view-usage-rights-products-item-text-sub-title">
                      {getCurrencyLogo(currency)}
                      {productDetails?.productPrice}
                    </div>
                  </div>
                </div>
                <div className="view-usage-rights-products-item-right">
                  {productDetails?.variantDetail &&
                    Object.entries(productDetails?.variantDetail).map(
                      ([key, value]) => (
                        <div>
                          <span className="view-usage-rights-variant-key">
                            {key}:{' '}
                          </span>
                          <span className="view-usage-rights-variant-value">
                            {value}
                          </span>
                        </div>
                      ),
                    )}
                </div>
              </div>
            ),
          )}
        </>
      );
    }
    return <></>;
  };

  return (
    <>
      <div className="view-usage-rights__terms__section">
        <div className="view-usage-rights__terms__section__left">💰 Offer</div>
        <div className="view-usage-rights__terms__section__right">
          {renderNumericOffer()}
        </div>
      </div>
      {renderPayWithProduct()}
    </>
  );
};

export default ViewUsageRightOffer;
